/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id, projectId: ZodTypes.Id });

export const PostProjectUsers = {
  id: 'project-users.post',
  tag: 'Project',
  summary: 'Add project users',
  description: 'Add new members (users and teams) to a project',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/project/${params.projectId}/user`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            users: z.array(z.strictObject({ id: ZodTypes.Id })),
            teams: z.array(z.strictObject({ identifier: ZodTypes.Team.Identifier })),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: { 'application/json': { schema: z.string().optional() } },
    },
  },
} as const satisfies Endpoint;
